import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Spin } from 'antd';
import { withTranslation } from 'react-i18next';
import FooterMenu from '../../components/Guest/Footer/Footer';
import './HomeSelectService.css';

@inject('amenityStore', 'loginStore', 'CmsLanguageStore', 'templateStore', 'webSettingStore')
@observer
class HomeSelectService extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { amenityStore, loginStore, CmsLanguageStore } = this.props;
    const roomNo = loginStore.getRoomNo();

    // 直接访问/刷新本页时 store 里还没有模板数据，需要主动拉一次
    this.props.templateStore.getActive();

    const params = new URLSearchParams(this.props.history.location.search);
    const taskId = params.get('taskId');


    const languageCode = localStorage.getItem('lang') || 'en';
    const { activeLanguages } = CmsLanguageStore;
    const language = activeLanguages.find(fi => fi.code === languageCode);
    const languageId = language ? language.id : 1;

    amenityStore.setShowAmenityDetailModal(false);
    amenityStore.getMultiList(roomNo, languageCode, languageId, taskId);
  }

  componentWillUnmount() {
    this.props.amenityStore.resetData();
  }

  menuClick = (taskID, menuType, isSoon, redirectUrl) => {
    const {
      activeLanguages
    } = this.props.CmsLanguageStore;

    const lang = window.localStorage.getItem('lang') || 'en';
    let languageId = 1;
    if (lang && activeLanguages.length > 0) {
      const language = activeLanguages.find(fi => fi.code === lang);
      if (language) {
        languageId = activeLanguages.find(fi => fi.code === lang).id;
      }
    }

    if (isSoon) {
      this.menuSoonClick();
    } else {
      switch (menuType) {
        case 'AMENITY':
          this.props.history.push(`amenity`);
          break;

        case 'HK_SERVICE':
        case 'CONCIERGE':
        case 'DEFECT_REPORT':
        case 'DND':
        case 'FRONT_OFFICE':
        case 'LATE_CHECKOUT':
          this.props.history.push(`single-list/${taskID}/language/${languageId}`);
          break;

        case 'BOOKING_FACILITY':
          this.props.history.push(`booking`);
          break;

        case 'IN_ROOM_DINING':
          this.props.history.push(`fnb`);
          break;

        case 'IN_ROOM_DINING_URL':
          if (redirectUrl) {
            window.open(redirectUrl, '_blank');
          } else {
            console.warn('Redirect URL is not configured for this menu');
          }
          break;

        case 'LAUNDRY':
          this.props.history.push(`laundry`);
          break;

        case 'PRINT_FILE':
          this.props.history.push(`print-file`);
          break;

        case 'RCU_CONTROL':
          this.props.history.push(`rcu-control`);
          break;

        case 'SHOPPING':
          this.props.history.push(`shopping`);
          break;

        case 'SPA':
          this.props.history.push(`spa`);
          break;

        case 'TRANSPORTATION':
          this.props.history.push(`transportation`);
          break;

        case 'TV_CHANNEL':
          this.props.history.push(`tv-channel`);
          break;

        case 'WAKE_UP_CALL':
          this.props.history.push(`wakeup-call`);
          break;

        default:
          break;
      }
    }
  }


  // ==================== Navigation ====================

  handleCardClick = (category) => {
    const { history, amenityStore } = this.props;
    amenityStore.amenityTabCategoryIdActive = category.taskId.toString();
    if (category.subCategories && category.subCategories.length > 0) {
      amenityStore.amenityTabSubCategories = category.subCategories;
    }
    history.push('/amenity');
  };

  handleBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  // ==================== Render Helpers ====================

  renderCard = (category) => {
    const { activeTemplate } = this.props.templateStore;

    return (
      <div
        className="stm-hss-card"
        key={category.taskId}
        onClick={() => this.menuClick(category.taskId, category.menuType, false, '')}
        style={{
          fontFamily: activeTemplate ? activeTemplate.templateSetting.text.fontFamily : 'inherit',
        }}
      >
        {category.imageUrl && (
          <div className="stm-hss-card-img">
            <img src={category.imageUrl} alt={category.taskName || 'icon'} />
          </div>
        )}
        <div className="stm-hss-card-text">
          <div className="stm-hss-card-title">{category.taskName || '—'}</div>
          {category.taskDesc && (
            <div
              className="stm-hss-card-sub"
              dangerouslySetInnerHTML={{ __html: category.taskDesc }}
            ></div>
          )}
        </div>
        <div className="stm-hss-card-arrow">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path d="M9 6L15 12L9 18" stroke="#1a1a1a" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      </div>
    );
  };

  // ==================== Render ====================

  render() {
    const { t, amenityStore, templateStore, webSettingStore } = this.props;
    const { amenityTabCategories } = amenityStore;
    const { activeTemplate } = templateStore;
    const { data: webSetting } = webSettingStore;

    return (
      <div className="stm-hss-page">
        <div
          className="stm-hss-hero"
          style={
            amenityStore.menu?.bannerUrl
              ? {
                  backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.05) 60%, rgba(0, 0, 0, 0.45) 100%), url(${amenityStore.menu.bannerUrl})`,
                }
              : {}
          }
        >
          <button className="stm-hss-back-btn" onClick={this.handleBack} aria-label="Back">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M19 12H5m0 0l7-7m-7 7l7 7" stroke="#fff" strokeWidth="2"
                strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <div className="stm-efa-hero-content">
            <h1 className="stm-efa-hero-title">{amenityStore.menu ? amenityStore.menu.taskName : ''}</h1>
          </div>
        </div>

        <div className="stm-hss-content">
          {amenityStore.amenityTabLoading ? (
            <div className="stm-hss-empty">
              <Spin
                spinning={true}
                tip={webSetting ? webSetting.loadingDataText : 'Loading...'}
                style={{
                  fontFamily: activeTemplate ? activeTemplate.templateSetting.text.fontFamily : 'inherit',
                  color: activeTemplate ? activeTemplate.templateSetting.text.color : '#aaa',
                  fontSize: activeTemplate ? activeTemplate.templateSetting.text.fontSize : '14px'
                }}
              />
            </div>
          ) : amenityTabCategories.length === 0 ? (
            <div className="stm-hss-empty">
              <p>{t ? t('noData') : ''}</p>
            </div>
          ) : (
            <div className="stm-hss-list">
              {amenityTabCategories.map((category) => this.renderCard(category))}
            </div>
          )}
        </div>

        <FooterMenu history={this.props.history} menuText={'home'} />
      </div>
    );
  }
}

export default withTranslation()(HomeSelectService);
